<template>
  <div class="page-layout">
    <el-aside width="200px" class="nav-left">
      <Steper :data="modulers" :current="current" />
    </el-aside>
    <Content class="c-create-scroll" style="position: relative; overflow: auto; -webkit-overflow-scrolling: touch">
      <router-view />
    </Content>
  </div>
</template>
<script>
import { isArray, camelcase } from '@/common/js/utils'
import { getSession } from '@/common/js/api'
import Steper from '@/components/steper'

export default {
  name: 'CreateMain',
  components: {
    Steper
  },
  computed: {
    component() {
      const { path } = this.$route
      return isArray(path.split('/')) && path.split('/')[3]
    },
    current() {
      const model = ['group', 'plan', 'idea', 'batch']
      const robot = ['project', 'monitor']
      const toutiaonew = ['project', 'advertise', 'batchnew']
      const toutiaov2 = ['projectedit', 'adedit']
      if (this.component && model.includes(this.component)) return model.indexOf(this.component)
      else if (this.component && robot.includes(this.component)) return robot.indexOf(this.component)
      else if (this.component && toutiaonew.includes(this.component)) return toutiaonew.indexOf(this.component)
      else if (this.component && toutiaov2.includes(this.component)) return toutiaov2.indexOf(this.component)
      else return 0
    },
    media() {
      const { path } = this.$route
      const media = isArray(path.split('/')) && path.split('/')[2]
      return camelcase(media)
    },
    modulers() {
      console.log('camelcase(this.media) output: ', camelcase(this.media))
      return this.$store.state[camelcase(this.media)].modulers
    }
  },
  created() {
    const { account, admin, media, currentModule } = this.$store.state[this.media]
    if (!account) {
      this.$store.commit(`${this.media}/setAccount`, getSession('qianduan_media_account_id'))
    }
    if (!admin) {
      this.$store.commit(`${this.media}/setAdmin`, getSession('qianduan_media_account_name'))
    }
    if (!media) {
      this.$store.commit(`${this.media}/setMedia`, getSession('qianduan_media_id'))
    }
    if (this.component !== currentModule) this.changeStoreCurrent()
  },
  methods: {
    changeStoreCurrent() {
      this.$store.commit(`${this.media}/setCurrent`, this.component)
    }
  },
  watch: {
    $route: {
      handler() {
        this.changeStoreCurrent()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-left {
  background: #fff;
  box-shadow: 0px 2px 4px 0px #eff1fa;
  padding: 22px 15px;
}
</style>
